import React from "react";
import styles from './Filter.module.scss';
import Icon from "../icon/Icon";
import PropTypes from "prop-types";

const Filter = ({
  filters,
  selected,
  onChange
}) => {
  return (
    <div className={styles.filter}>
      {filters.map((filter) => <button
        key={filter.label}
        type="button"
        className={filter.value === selected ? styles.active : ''}
        onClick={() => onChange(filter.value ?? null)}
        disabled={filter.isDisabled}
      >
        {filter.icon && <Icon name={filter.icon} />}
        {filter.label}
      </button>)}
    </div>
  );
};

Filter.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
      icon: PropTypes.string,
      isDisabled: PropTypes.bool,
    })
  ).isRequired,
  selected: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default Filter;
